import ZendeskModel from './model/zendesk.model';

class ZendeskController {
  constructor($window, TicketsApiService, StorageService, $timeout, $translate, ProfileApiService) {
    'ngInject';

    this.$window = $window;
    this.TicketsApiService = TicketsApiService;
    this.StorageService = StorageService;
    this.$timeout = $timeout;
    this.profileApiService = ProfileApiService;
    this.$translate = $translate;
  }

  $onInit() {
    this.model = new ZendeskModel();
    this.loadTickets();

    this.menuHighlight();
  }

  loadTickets() {
    let memberDetails = JSON.parse(this.StorageService.getItem('member_details'));

    this.profileApiService.profile().then((userDetails) => {
      this.model.id = userDetails.zendesk_id;
    });

    this.TicketsApiService.fetchTickets().then((tickets) => {
      this.model.ticketCount = tickets.summary;
      this.model.tickets = tickets.tickets.reverse();
      this.model.memberDetails = memberDetails;
      this.renderTable();
    });
  }

  renderTable() {
    $('#datatable-responsive').footable();
    $('#datatable-responsive').trigger('footable_redraw');
  }

  openMessage(ticketId, status, subject) {
    const payload = {
      ticketId: ticketId
    }

    let spin = document.querySelector('#conversation .spinner');

    this.$timeout(() => {
      spin.classList.remove('hidden');
      $('#conversation').modal('show');
    }, 500);

    this.model.activeSubject = subject;
    this.model.activeMessage = message;
    this.model.statusText = this.model.getStatusText(this.$translate.instant(status));
    this.model.statusColor = this.model.getStatusColor(status);
    this.model.ticketDescription = [];
    
    this.TicketsApiService.fetchTicketDetails(payload).then((ticketDetails) => {
      const channel = ticketDetails.comments[0].via.channel;

      if (channel == 'chat') {
        this.model.ticketDescription = ticketDetails.comments;
        this.model.chatStatus = 'chat'
      } else {
        this.model.ticketDescription = ticketDetails.comments;
        this.model.chatStatus = 'ticket'
      }

      this.$timeout(() => {  spin.classList.add('hidden'); }, 100);
    });  
  }

  menuHighlight() {
    this.$timeout(() => {
      $('#tickets').addClass('subdrop');
    }, 100);
  }
}

export default ZendeskController;



// WEBPACK FOOTER //
// ./client/app/pages/zendesk/zendesk.controller.js